import type { CSSProperties, ReactElement } from "react";
import { Badge, Stack, Text } from "@ux/primitives";
import { palette, space } from "@ux/tokens";
import type { FloorplanStats } from "../../admin/workspaces/types";

export interface FloorplanStatsBarProps {
    readonly stats: FloorplanStats;
    readonly officeLabel: string;
}

export function FloorplanStatsBar({
    stats,
    officeLabel,
}: FloorplanStatsBarProps): ReactElement {
    return (
        <div style={barStyle}>
            <Text role="muted">{officeLabel}</Text>
            <Stack direction="row" gap={2} align="center" wrap>
                <Badge tone="neutral">{stats.totalDesks} desks</Badge>
                <Badge tone="accent">{stats.occupied} occupied</Badge>
                <Badge tone="ok">{stats.vacant} vacant</Badge>
            </Stack>
        </div>
    );
}

const barStyle: CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: space[3],
    flexWrap: "wrap",
    padding: `${space[2]} ${space[4]}`,
    borderBottom: `1px solid ${palette.border}`,
    background: palette.surface,
};
